import { useMutation } from 'react-query'

import AuthDataService from 'src/services/auth.service'

import { joinAbsRoute, joinRelRoute } from 'src/common/utils'
import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { IConfirmLoginByProviderDto } from 'src/types'
import { useNavigate } from 'react-router-dom'

export const useConfirmLoginByProvider = () => {
  const navigate = useNavigate()

  return useMutation(
    (dto: IConfirmLoginByProviderDto) => AuthDataService.confirmLoginByProvider(dto),
    {
      onSettled: (data, _, vars) => {
        if (!data) return

        if (data.accessToken && data.refreshToken) {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
          localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)

          navigate(
            data.accountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
              : data.scannerAccountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
              : joinAbsRoute(ROUTES.ACCOUNTS),
          )
        }

        if (typeof data.agreement !== 'undefined' && !data.agreement) {
          navigate({
            pathname: joinRelRoute(ROUTES.REGISTER_FINISH),
            search: `?userId=${vars.id}&email=${vars.email}`,
          })
        }
      },
    },
  )
}
